export default __webpack_public_path__ + "static/media/ACGR SCORECARD for 2024.d20ed0e6.pdf";